var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { flatArrays, getPropsByKeyPath, valueExist } from 'src/shared/helpers/objHelpers';
import { E_STATUS } from 'src/shared/types';
import { getScoreMachine } from './qpcConverter';
export var sortControlsListByStatus = function (a, b) {
    var _a;
    var STATUS_VALUE = (_a = {},
        _a[E_STATUS.KO] = 0,
        _a[E_STATUS.UNKNOWN] = 1,
        _a[E_STATUS.OK] = 2,
        _a);
    var mappedA = STATUS_VALUE[a.status || E_STATUS.UNKNOWN];
    var mappedB = STATUS_VALUE[b.status || E_STATUS.UNKNOWN];
    return mappedA - mappedB;
};
export var parseExtractedData = function (extractedData) {
    var mrzValues = extractedData
        .filter(function (data) { return data.code.startsWith('mrz.line'); })
        .sort(function (a, b) { return a.code.localeCompare(b.code); })
        .map(function (data) { return data.value; });
    return { mrz: mrzValues || null };
};
export var getDigitalIdDescription = function (i18n, control, applicant) {
    var _a, _b;
    var status = control.status;
    switch (status) {
        case E_STATUS.OK:
            return getPropsByKeyPath(i18n.keyValueMap, 'kycScore.digitalId.ok.description').replace('$provider', ((_a = applicant === null || applicant === void 0 ? void 0 : applicant.kycScore) === null || _a === void 0 ? void 0 : _a.digitalIdProvider) || '');
        case E_STATUS.KO:
            return getPropsByKeyPath(i18n.keyValueMap, 'kycScore.digitalId.ko.description').replace('$provider', ((_b = applicant === null || applicant === void 0 ? void 0 : applicant.kycScore) === null || _b === void 0 ? void 0 : _b.digitalIdProvider) || '');
        case E_STATUS.UNKNOWN:
            return getPropsByKeyPath(i18n.keyValueMap, 'kycScore.digitalId.none.description');
    }
};
export var parseGCPCheckListItem = function (i18n, control, doc, applicant) {
    var _a, _b, _c;
    var isMRZ = ((_b = (_a = control.scoreMaskUpdateParameters) === null || _a === void 0 ? void 0 : _a.controlCodes) === null || _b === void 0 ? void 0 : _b.includes('tech.invalidDoc')) ||
        ((_c = control.extractedData) === null || _c === void 0 ? void 0 : _c.some(function (data) { return ['document.mrzCheckDigits', 'document.mrzSyntax'].includes(data.code); }));
    var isDigitalId = doc.code === 'DIGITAL_ID';
    return {
        status: control.status,
        description: isDigitalId ? getDigitalIdDescription(i18n, control, applicant) : control.instructions,
        values: control.extractedData.map(function (detail) {
            var labelTranslated = getPropsByKeyPath(i18n.keyValueMap, detail.label);
            return "".concat(labelTranslated).concat(detail.value ? ": ".concat(detail.value) : null);
        }),
        isMRZ: isMRZ,
        scoreTags: [],
    };
};
export var filterInvalidFile = function (item) {
    return valueExist(item) &&
        item.fileId &&
        typeof item.fileId === 'string' &&
        item.fileId.length > 0 &&
        item.fileUrl &&
        item.fileUrl !== 'fakeFileUrl';
};
export var parseGCPCaseDetails = function (i18n, applicants, documents) {
    if (!documents || documents.length < 1) {
        console.error('An error occurred : During GCP data conversion no documents provided');
        return {};
    }
    return documents
        .filter(function (doc) { return doc.documents.length > 0; })
        .map(function (doc) {
        var files = doc.documents.filter(filterInvalidFile);
        var allExtractedData = flatArrays(doc.checkList.map(function (checkListItem) { return checkListItem.extractedData; }));
        var applicant = applicants[doc.applicantNum];
        var docControls = doc.checkList
            .map(function (checkListItem) { return parseGCPCheckListItem(i18n, checkListItem, doc, applicant); })
            .sort(sortControlsListByStatus);
        var machineKYC = getScoreMachine(docControls);
        return {
            controls: {
                collection: docControls,
                targetScore: null,
            },
            files: files.map(function (file) { return ({ url: file.fileUrl, name: file.title }); }),
            id: doc.code,
            label: doc.stepTitle,
            machineKYC: machineKYC,
            nbOfFiles: files.length,
            status: { value: E_STATUS[doc.humanStatus] || E_STATUS[doc.machineStatus] || E_STATUS.UNKNOWN, isLoading: false },
            studyNumber: doc.studyNumber,
            applicant: applicant.id,
            isFilesToMerge: doc.toMerge,
            extractedData: parseExtractedData(allExtractedData),
            decisionDisabled: doc.decisionDisabled,
        };
    })
        .reduce(function (acc, doc) {
        var _a;
        var applicant = doc.applicant, restDoc = __rest(doc, ["applicant"]);
        var accDocumentsOfApplicant = acc[applicant] ? acc[applicant].documents : [];
        return __assign(__assign({}, acc), (_a = {}, _a[applicant] = { documents: __spreadArray(__spreadArray([], accDocumentsOfApplicant, true), [restDoc], false) }, _a));
    }, {});
};
